import Grid from '@mui/material/Grid'
import { Thread } from 'api/bulletinBoard/bulletinBoard.api'
import { useSystems } from 'api/systems/systems.api'
import React, { ReactElement, useState } from 'react'

import BulletinBoardTextField from '../TextField/TextField'

import SystemsPicker from './components/SystemsPicker/SystemsPicker'

type BulletinBoardNewThreadProps = {
  threads: Thread[]
  onFilterClick?: () => void
  filterOnUserPosts?: boolean
}

function BulletinBoardNewThread({
  threads,
  onFilterClick,
  filterOnUserPosts,
}: BulletinBoardNewThreadProps): ReactElement {
  const [sendList, setSendList] = useState<Array<number>>([])
  const { data: systems = [] } = useSystems()
  return (
    <>
      <SystemsPicker
        currentSystems={Object.values(systems).sort((a, b) => {
          if (a.display_name === b.display_name) {
            return 0
          }
          if (!a.display_name && b.display_name) {
            return -1
          }
          if (a.display_name && !b.display_name) {
            return 1
          }

          return a.display_name?.localeCompare(b.display_name as string) as number
        })}
        sendList={sendList}
        setSendList={setSendList}
        onFilterClick={onFilterClick}
        filterOnUserPosts={filterOnUserPosts}
      />
      <Grid container direction="row" sx={{ flexGrow: 1 }}>
        <BulletinBoardTextField ids={sendList} type="thread" content={threads ? threads.length : 0} />
      </Grid>
    </>
  )
}

export default BulletinBoardNewThread
